export default "__VITE_ASSET__DiOa$iPY__"